var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConversationOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.6 14",
    style: {
      enableBackground: "new 0 0 17.6 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B4A64;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.9,0H5.6C2.5,0,0,2.5,0,5.6c0,3.1,2.5,5.6,5.6,5.6h1C7.8,13.7,11,14,11,14s0-1.4,0-2.7h1 c3.1,0,5.6-2.5,5.6-5.6C17.6,2.5,15,0,11.9,0z M11.9,9.7H9.4l0,1.6c0,0.2,0,0.4,0,0.6c-0.5-0.3-1-0.7-1.3-1.2L7.7,9.7h-2 c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4C16,7.9,14.2,9.7,11.9,9.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConversationOutline);
export default __webpack_public_path__ + "static/media/icon-conversation-outline.5a2abfe87b182ccad9a94c39c437798d.svg";
export { ForwardRef as ReactComponent };